import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { WORKBOOK_DASHBOARD_LIST_ENTITY_NAME } from '../../dashboard/const';
import { WorkbookDashboardListState } from '../models';

@Injectable({ providedIn: 'root' })
export class WorkbookDashboardListStore extends EntityCollectionServiceBase<WorkbookDashboardListState> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super(WORKBOOK_DASHBOARD_LIST_ENTITY_NAME, serviceElementsFactory);
  }
}
